import React,{useState, useEffect} from 'react'
import { Link } from 'react-router-dom'
import hero from '../../asset/heroSectionTypography.svg'
import linkArrow from '../../asset/arrowRight.svg'
import cursorIcon from '../../asset/cursorIcon.png'
import cursorPointer from '../../asset/Pointer.png'
import "./home.css"
import Particles from 'react-tsparticles'
import { animate, motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer';
import { useAnimation } from 'framer-motion'

//import '../Particlejs/PJSconfig'
//import '../Particlejs/particles'



export default function Home() {

  const [cX, setCX] = useState()
  const [cY, setCY] = useState()
  const [cursor, setCursor] = useState(false)
  const [introRef, introInView] = useInView();
  const [dreamRef, dreamInView] = useInView();


  const handleMouseUpdate = (e)=>{
    const x = (window.innerWidth - e.clientX)/100
    const y = (window.innerHeight - e.clientY)/100
    setCX(x);
    setCY(y)
  }
  const variants = {
    opFxF: { opacity: 1, x: 0 },
    opNoxNo: { opacity: 0, x: "-100%" },
    yNo:{y:'100%', opacity:0},
    yF:{y:0, opacity:1},
    titleInit:{x:'-100%', opacity:0},
    titileAnim:{x:0, opacity:1},
    xkey:["20px", "-80px", "40px ", " -20px" ],
    ykey:["80px", "-40px", "60px ", " -60px" ],

  }

  useEffect(() => {

    const elm = document.getElementById('hero')
    elm.addEventListener('mousemove', handleMouseUpdate)
    
    const cursor = document.querySelector('.mousePointerIcon');

    document.addEventListener('mousemove', e => {
        cursor.setAttribute("style", "display:block; "+ "top: "+(e.clientY-20)+"px; left: "+(e.clientX - 20)+"px;")
    })
        
    const links = document.getElementsByTagName('a')
    for (const link of links) {
        link.addEventListener('mouseover', e =>{setCursor(true)})
        
        setTimeout(function(){
          link.addEventListener('mouseleave', e =>{setCursor(false)})
        }, 500); 
    }

    return () => {
      elm.removeEventListener('mousemove', handleMouseUpdate)
    }
  }, [introInView])

  return (
    <div className="home">
      <div className="mousePointerIcon">
        {cursor ? <img className='cursorPointer'src={cursorPointer} alt=""/> : <img className='cursor' src={cursorIcon} alt=""/>}
      </div>
      <section className="hero" id='hero' >
        <Particles options={
          {
            "particles": {
              "number": {
                "value": 225,
                "density": {
                  "enable": true,
                  "value_area": 4000
                }
              },
              "color": {
                "value": "#E1FF31"
              },
              "shape": {
                "type": "polygon",
                "stroke": {
                  "width": 0,
                  "color": "#000000"
                },
                "polygon": {
                  "nb_sides": 12
                },
                "image": {
                  "src": "https://www.google.com/url?sa=i&url=https%3A%2F%2Funsplash.com%2Fs%2Fphotos%2Frandom&psig=AOvVaw0Zf-bt0KsE_FyQKYx1Q5n9&ust=1649770935374000&source=images&cd=vfe&ved=0CAoQjRxqFwoTCOii1uWRjPcCFQAAAAAdAAAAABAD",
                  "width": 100,
                  "height": 100
                }
              },
              "opacity": {
                "value": 0.5,
                "random": false,
                "anim": {
                  "enable": false,
                  "speed": 1,
                  "opacity_min": 0.1,
                  "sync": false
                }
              },
              "size": {
                "value": 3,
                "random": true,
                "anim": {
                  "enable": false,
                  "speed": 40,
                  "size_min": 0.1,
                  "sync": false
                }
              },
              "line_linked": {
                "enable": true,
                "distance": 150,
                "color": "#8DFFA8",
                "opacity": 0.4,
                "width": 1
              },
              "move": {
                "enable": true,
                "speed": 2,
                "direction": "none",
                "random": false,
                "straight": false,
                "out_mode": "out",
                "bounce": false,
                "attract": {
                  "enable": false,
                  "rotateX": 600,
                  "rotateY": 1200
                }
              }
            },
            "interactivity": {
              "detect_on": "canvas",
              "events": {
                "onhover": {
                  "enable": true,
                  "mode": "grab"
                },
                "onclick": {
                  "enable": true,
                  "mode": "repulse"
                },
                "resize": true
              },
              "modes": {
                "grab": {
                  "distance": 400,
                  "line_linked": {
                    "opacity": 0.4277652555897406
                  }
                },
                "bubble": {
                  "distance": 400,
                  "size": 40,
                  "duration": 2,
                  "opacity": 8,
                  "speed": 3
                },
                "repulse": {
                  "distance": 162.41544246026902,
                  "duration": 0.4
                },
                "push": {
                  "particles_nb": 4
                },
                "remove": {
                  "particles_nb": 2
                }
              }
            },
            "retina_detect": true
          }
        }/>
        <img id="heroImgID" className='heroImg' src={hero} alt=""  style={{ transform: `translateX(${cX}px) translateY(${cY}px)` }} />
        <p>Made With Love💕</p>
      </section>

      <section id='intro' className="intro">
        <div id='introContent' className="introContent">
          <div id='introContentLeft' className="introContentLeft"> 
            <motion.p variants={variants}  animate={ introInView ? "opFxF":"opNoxNo"} transition={{type:'tween',delay:.8}} >About</motion.p>
            <motion.h1 variants={variants}  animate={ introInView ? "titileAnim":"titleInit"} transition={{type:'tween', duration:1}}>
                We  Are
             <br />The<br /> woOeNe</motion.h1>
          </div>
          <div ref={introRef} id='introContentRight' className="introContentRight">
            <motion.p variants={variants}  animate={ introInView ? "yF":"yNo"}
            transition={{ type: "tween", duration:.5}}>For ten years, the web&nbsp; 
              <svg width="24" height="24" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.14999 49.07H94.3" stroke="#88FFA4" strokeWidth="5.82" strokeMiterlimit="10"></path><path d="M94.3099 49.07C94.3099 58.0849 91.6368 66.8973 86.6284 74.3929C81.62 81.8885 74.5013 87.7306 66.1727 91.1804C57.844 94.6303 48.6794 95.5329 39.8378 93.7742C30.9961 92.0155 22.8745 87.6744 16.5001 81.2999C10.1256 74.9255 5.78448 66.8039 4.02576 57.9622C2.26705 49.1206 3.16967 39.9559 6.61951 31.6273C10.0694 23.2986 15.9115 16.18 23.4071 11.1716C30.9027 6.16324 39.7151 3.49 48.73 3.49C54.7156 3.49 60.6427 4.66893 66.1727 6.95954C71.7027 9.25015 76.7274 12.6076 80.9599 16.8401C85.1924 21.0726 88.5498 26.0972 90.8404 31.6273C93.131 37.1573 94.3099 43.0844 94.3099 49.07V49.07Z" stroke="#88FFA4" strokeWidth="5.82" strokeMiterlimit="10"></path><path d="M70.6 49.07C70.6 74.24 60.81 94.64 48.73 94.64C36.65 94.64 26.87 74.24 26.87 49.07C26.87 23.9 36.66 3.49 48.73 3.49C60.8 3.49 70.6 23.9 70.6 49.07Z" stroke="#88FFA4" strokeWidth="5.82" strokeMiterlimit="10"></path><path d="M48.73 3.49V94.64" stroke="#88FFA4" strokeWidth="5.82" strokeMiterlimit="10"></path><path d="M94.31 49.07C94.31 60.59 73.9 69.94 48.73 69.94C23.56 69.94 3.16 60.59 3.16 49.07C3.16 37.55 23.56 28.19 48.73 28.19C73.9 28.19 94.31 37.54 94.31 49.07Z" stroke="#88FFA4" strokeWidth="5.82" strokeMiterlimit="10"></path></svg>
                &nbsp;is our playground. We know its laws by heart, it s shortcuts, its thousand jargons and its secret spots. And we've had fun with you for ten years.
            </motion.p>
            
            <motion.p variants={variants}  animate={ introInView ? "yF":"yNo"}
            transition={{ type: "tween", delay:.25, duration:.5 }}            
            >We are the studio that finest&nbsp; 
            <svg width="25" height="25" viewBox="0 0 99 93" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M49.3 27.75C49.25 -0.810013 3.39999 -7.93001 3.44999 28.75C3.49999 65.43 48.4 89.87 48.4 89.87H50.4C50.4 89.87 95.21 65.33 95.16 28.61C95.11 -8.11003 49.25 -0.810013 49.3 27.75Z" stroke="#88FFA4" strokeWidth="5.82" strokeMiterlimit="10"></path></svg>
              &nbsp;designs  and develop quality webServer.
            </motion.p>

            <motion.p variants={variants}  animate={ introInView ? "yF":"yNo"}
            transition={{ type: "tween", delay:.3, duration:.5 }}
            >We are the woOeNe.</motion.p>
            <motion.div variants={variants}  animate={ introInView ? "opFxF":"opNoxNo"}
            transition={{type:'sprng' , delay:.45, duration:.5}}
            >
                <Link id='detailLinks'  className='detailLinks' to='/about'>FIND OUT <br /> MORE <img src={linkArrow} alt="" /></Link>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="work" id='workSection'>
        <div id='workContainer' className="workContainer" >
          <Link to='works' className="workLinks">
            <motion.div id='cardContainer' className="cardContainer" 
            animate={{x:[0, -40, 67, 37, -90, 0], y:[0, 20, -40, 77, 97, 0]}} 
            transition={{type:"tween", duration:60, yoyo:Infinity,}}>
              <div id='cardArrow' className="cardArrow">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#FFFF31FF" strokeWidth="1.5" strokeMiterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#FFFF31FF" strokeWidth="1.5" strokeMiterlimit="10"></path></svg>
              </div>
              <div id='cardTitle' className="cardTitle">
                <p>Example Project 1</p>
              </div>
                <div id='imgAnimHideDiveBig' className="imgAnimHideDiveBig">
                  <div id='cardImg' className="cardImg">
                    <img src="https://res.cloudinary.com/neuvieme-page/image/upload/w_800,q_auto:good,f_auto/v1644400347/studio-9p/uploads/image-cover-fooding.jpg" alt="" />
                  </div>
                </div>
            </motion.div>
          </Link>


          <Link to='works' className='workLinks'>
          <motion.div
          animate={{x:[0, -50, 57, -57, 60, 0], y:[0, 40, -60, 47, 67, 0]}} 
            transition={{type:"tween", duration:60, yoyo:Infinity,}}
          id='cardContainer2' className="cardContainer2">
            <div id='cardArrow2' className="cardArrow2">
            <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#8DFFA8" strokeWidth="1.5" strokeMiterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#8DFFA8" strokeWidth="1.5" strokeMiterlimit="10"></path></svg>
            </div>
            <div id='cardTitle' className="cardTitle2">
              <p>Example Project 2</p>
            </div>
            <div id='imgAnimHideDive' className="imgAnimHideDive">
              <div id='cardImg' className="cardImg2">
                <img src="https://res.cloudinary.com/neuvieme-page/image/upload/w_800,q_auto:good,f_auto/v1644400347/studio-9p/uploads/image-cover-fooding.jpg" alt="" />
              </div>
            </div>
          </motion.div>
          </Link>

    	    <Link to='works' className='workLinks'>
            <motion.div             
            animate={{x:[0, 40, -57, -37, 70, 0], y:[0, -27, 39, 51, -73, 0]}} 
            transition={{type:"tween", duration:50, yoyo:Infinity,}} id='cardContainer3' className="cardContainer3">
              <div id='cardArrow3' className="cardArrow3">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#8DFFA8" strokeWidth="1.5" strokeMiterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#8DFFA8" strokeWidth="1.5" strokeMiterlimit="10"></path></svg>
              </div>
              <div id='cardTitle' className="cardTitle3">
                <p>Rosvar</p>
              </div>
              <div id='imgAnimHideDiveBig' className="imgAnimHideDiveBig">
                <div id='cardImg' className="cardImg3">
                  <img src="https://res.cloudinary.com/neuvieme-page/image/upload/w_800,q_auto:good,f_auto/v1644400347/studio-9p/uploads/image-cover-fooding.jpg" alt="" />
                </div>
              </div>
            </motion.div>
          </Link>

          <Link to='works' className='workLinks'>
            <motion.div 
            animate={{x:[0, -64, 43, -27, 40, 0], y:[0, -27, 31, -54, 61, 0]}} 
            transition={{type:"tween", duration:60, yoyo:Infinity,}} id='cardContainer4' className="cardContainer4">
              <div id='cardArrow4' className="cardArrow4">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#E1FF31" strokeWidth="1.5" strokeMiterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#E1FF31" strokeWidth="1.5" strokeMiterlimit="10"></path></svg>
              </div>
              <div id='cardTitle' className="cardTitle4">
                <p>Rosvar</p>
              </div>
              <div id='imgAnimHideDive' className="imgAnimHideDive">
                <div id='cardImg' className="cardImg4">
                  <img src="https://res.cloudinary.com/neuvieme-page/image/upload/w_800,q_auto:good,f_auto/v1644400347/studio-9p/uploads/image-cover-fooding.jpg" alt="" />
                </div>
              </div>
            </motion.div>
          </Link>
          
        </div>
        <div id='dLinkW'  className="dLinkW">
          <Link to='works' id='detailLinks' className='detailLinks' >Load More Works <img src={linkArrow} alt="" /></Link>
        </div>
      </section>

      <section id='dream' className="dream" ref={dreamRef}>
      <div id='dreamContent' className="dreamContent">
          <div id='dreamContentLeft' className="dreamContentLeft">
            <motion.p variants={variants}  animate={ dreamInView ? "titleAnim":"titleInit"} transition={{type:'tween',delay:.8}}>ready to dream</motion.p>
            <motion.h1 variants={variants}  animate={ dreamInView ? "titleAnim":"titleInit"} transition={{type:'tween', duration:1}}>we are ready</motion.h1>
          </div>
          <div id='dreamContentRight' className="dreamContentRight">
            <motion.p variants={variants}  animate={ dreamInView ? "yF":"yNo"}transition={{ type: "tween", duration:.5}}>With you, we share the same language and the same aversion to verbiage. We're even pretty sure you'll like our humor.</motion.p>
            <motion.p variants={variants}  animate={ dreamInView ? "yF":"yNo"}transition={{ type: "tween", delay:.25, duration:.5 }}  >In short, we are just a team of specialists who love their job, and who love to share it even more. Come with problems, we will make them solutions.</motion.p>
            <motion.p variants={variants}  animate={ dreamInView ? "yF":"yNo"}transition={{ type: "tween", delay:.3, duration:.5 }}>We are the woOeNe.</motion.p>

            <motion.div variants={variants}  animate={ dreamInView ? "opFxF":"opNoxNo"} transition={{type:'sprng' , delay:.45, duration:.5}}><Link className='detailLinks' to="/about">MEET<br /> THE TEAM <img src={linkArrow} alt="" /></Link></motion.div>
          </div>
        </div>
      </section>
    </div>
  )
}
